import React from 'react';
/*import '../../styles/requestConfirmed.css';*/
import '../../styles/uploadimage.css';
import '../../styles/accept-buy-request.css';
import { Redirect } from 'react-router-dom';
import { CountryDropdown, RegionDropdown, CountryRegionData } from 'react-country-region-selector';
export default class ConfirmBuyRequest extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            country: "",
            confirmed: false
        }
    }
    selectCountry(item) {
        this.setState({
            country: item
        })
    }

    handleConfirmBuyRequest() {
        this.setState({
            confirmed: true
        })

    }
    render() {

        if (this.state.confirmed) {
            return (
                <Redirect push to="requestconfirmed" />
            )
        }
        return (
            <div className="col-sm-12 background-grey">
                <article className="post-88 page type-page status-publish hentry">
                    <div className="woocommerce">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <div className="heading-welcome_">
                                    CONFIRM BUY REQUEST
                                    <hr className="line-category-name margin-auto"></hr>
                                </div>
                            </div>

                            <div className="col-sm-6 UploadPaintingCard no-margin padding-35 ConfirmBuyRequest">
                                <div className="col-md-12">

                                    <div className="row">
                                        <div className="col-md-4">

                                            <img src={require("../../assets/artwork_picture.png")}
                                                className="image-art" />

                                        </div>

                                        <div className="col-md-8 text-center-sm" style={{ "margin-left": -15 }}>

                                            <h3 className="art-name">Art Name here</h3>
                                            <p className="art-details">
                                                Price : 200USD *
                                            </p>

                                            <p className="art-details">

                                                Technique : Water color

                                            </p>

                                            <p className="art-details">
                                                Dimension : 200*300
                                            </p>

                                            <p className="art-details">
                                                Year : 2016
                                            </p>
                                            <p style={{ "margin-top": -10 }}>
                                                <span style={{ "font-size": 9, "margin-top": 0 }}><super>*</super> Shipping and handling charges extra</span>
                                            </p>
                                        </div>
                                    </div>


                                </div>


                                <h3 className="main-label">Delivery address</h3>

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="address1">Address Line 1 </label>
                                            <input className="input-text" type="text" name="address1" id="address1"
                                                value=""
                                                required />
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="address2">Address Line 2 </label>
                                            <input className="input-text" type="text" name="address2" id="address2"
                                                value=""
                                                required />
                                        </p>
                                    </div>
                                </div>

                                <div className="row ml-15 mr-15">
                                    <div className="col-md-6 pl-0">
                                        <div className="form-group">
                                            <p>
                                                <label htmlFor="city">City </label>

                                                <input className="input-text" type="text" name="city" id="city"
                                                    value=""
                                                    required />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 pr-0">
                                        <div className="form-group">
                                            <p>
                                                <label htmlFor="state">State </label>
                                                <input className="input-text" type="text" name="state" id="state"
                                                    value="" required />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="row ml-15 mr-15">

                                    <div className="col-md-6 pl-0">
                                        <div className="form-group">
                                            <p>
                                                <label htmlFor="country">Country </label>


                                                <CountryDropdown className="form-element-small-input"
                                                    value={this.state.country}
                                                    onChange={(val) => this.selectCountry(val)}
                                                />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-6 pr-0">
                                        <div className="form-group">
                                            <p>
                                                <label htmlFor="country">Zip  &nbsp; &nbsp; </label>


                                                <input className="input-text" type="text" name="zip" id="zip"
                                                    value=""
                                                    required />
                                            </p>
                                        </div>
                                    </div>

                                </div>


                                <h3 className="main-label"> Payment Details </h3>

                                <div className="col-md-12">
                                    <div className="form-group">
                                        <p>
                                            <label htmlFor="currency">Currency </label>

                                            <input className="input-text" type="text" name="currency" id="currency"
                                                value=""
                                                required />


                                        </p>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="form-group">
                                        <p>

                                            <input type="checkbox" name="requesttext"
                                                value="I want to request the Artist to give a discounted price" />
                                            I want to request the Artist to give a discounted price <br />

                                        </p>
                                    </div>
                                </div>


                                <input type="hidden" name="artId" value="" />

                                <input type="hidden" name="buy_requestId" value="" />


                                <p className="mt-15 mb-25 ml-15">
                                    <input type="submit" name="submit" className="masterpieces-primary-buttons btn-primary"
                                        id="Newsletter_feedback" style={{ "margin-top": 25 }}
                                        value="Confirm Buy Request" onClick={this.handleConfirmBuyRequest.bind(this)} />
                                </p>


                            </div>
                        </div>

                    </div>
                </article>
            </div >

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/requests_forms/confirm-buy-request.js